module.exports = __webpack_public_path__ + "img/google-play-badge-ru-cropped.33e13c28.png";